// import {
// 	Artist,
// 	CalmAtmosphere,
// 	InteractionOriented,
// 	Searcher,
// 	Servant
// } from '@components/competitions/levels/imamreza/results';
// import {Gender, PersonalityType, useCompetitionImamrezaContext} from '@context/CompetitionImamrezaContext';
// import React from 'react';
// import {ResultEmpty} from './ResultEmpty';
//
// const componentMap: Record<PersonalityType, React.ComponentType<{gender: Gender}>> = {
// 	artist: Artist,
// 	peaceful: CalmAtmosphere,
// 	interaction: InteractionOriented,
// 	servant: Servant,
// 	searcher: Searcher
// };
//
// export default function Result() {
// 	const {gender, type} = useCompetitionImamrezaContext();
// 	// Ensure both gender and type are valid
// 	if (!gender || !type || !(type in componentMap)) {
// 		return <ResultEmpty/>; // or show an error/fallback
// 	}
//
// 	const SelectedComponent = componentMap[type as PersonalityType];
//
// 	return <SelectedComponent gender={gender as Gender}/>;
// }

import {ResultEmpty} from '@components/competitions/levels/imamreza/ResultEmpty';
import {
	Artist,
	CalmAtmosphere,
	InteractionOriented,
	Searcher,
	Servant
} from '@components/competitions/levels/imamreza/results';
import {appConfig} from '@config';
import {Gender, Lang, PersonalityType} from '@context/CompetitionImamrezaContext';
import scopedI18n from '@locale/scoped-i18n';
import {saveLang} from '@utils/langStorage';
import axios from 'axios';
import React from 'react';
import {LoaderFunctionArgs, useLoaderData, useParams} from 'react-router-dom';

interface loader {
	request: Request;
	params: {};
	referral_code: string;
}

const componentMap: Record<PersonalityType, React.ComponentType<{
	gender: Gender,
	showDetails?: boolean,
	lang: Lang,
	referralCode: string
}>> = {
	artist: Artist,
	peaceful: CalmAtmosphere,
	interaction: InteractionOriented,
	servant: Servant,
	searcher: Searcher
};

type LoaderData = {
	referralCode: string,
	gender: Gender,
	type: PersonalityType,
	lang: Lang
}

export default function Result() {
	const {ref} = useParams();
	const {referralCode, gender, type, lang} = useLoaderData() as LoaderData;
	// Ensure both gender and type are valid
	if (!gender || !type || !(type in componentMap)) {
		return <ResultEmpty lang={lang}/>; // or show an error/fallback
	}
	saveLang(lang);
	scopedI18n.changeLanguage(lang);
	const SelectedComponent = componentMap[type as PersonalityType];
	
	return <SelectedComponent gender={gender as Gender} lang={lang} referralCode={referralCode} showDetails={true}/>;
}

export async function competitionResultImamrezaLoader({params}: LoaderFunctionArgs) {
	const {ref} = params;
	
	if (!ref) {
		throw new Error('Missing referral code in URL');
	}
	
	const res = await axios({
		url: `${appConfig.competition2.url}imamreza-result`,
		method: 'POST',
		data: {
			referral_code: ref
		}
	});
	
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data;
		// throw new Error(res.data.error || 'Failed to fetch result');
	}
}
